import React, { useState } from 'react';
import moment from 'moment';

import { SchedulingWidget } from 'featureLib/AppointmentWidget';

import { getFromSessionStorage } from 'common/utils/app.utils';
import { getFetchSlotApiConfig } from 'featureLib/AppointmentEdl/utils';
import { DATE_FORMATS } from 'featureLib/AppointmentEdl/constants';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';
import appConfig from 'config/config';
import { bookSlotsAsync, rescheduleSlotsAsync } from 'featureLib/AppointmentWidget/services';
import { MODULE_ID, SUMMARY_AUTHORIZATION_HEADER } from 'home/common/constants/constants';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import './index.scss';

const WidgetComponent = ({
  open,
  setOpen = () => {},
  title = '',
  appointmentData,
  setAppointmentData,
  siteReadyByDate,
  selectedOption,
  fetchOrder,
  appointmentId,
  setSelectedAppointmentId,
  selectedLineItem,
  setSlotBooked,
  customerNeedByDate,
  planDetail,
  orderDetail
}) => {
  const [error, setError] = useState('');

  const order = getCurrentOrder?.();
  const lead = getCurrentLead?.();
  const isMultiSite = lead?.journeyType === 'MULTI_SITE' || selectedLineItem?.siteReadiness;

  const connectivityLineItems = order && order.lead && order.lead.connectivityLineItems;
  const addressLine1 = order && order.companyAddress && order.companyAddress.addressLine1;

  const getInstallationAddress = () => {
    if (isMultiSite) {
      return (selectedLineItem && selectedLineItem.address && selectedLineItem.address.addressLine1) || '';
    }

    return addressLine1 ? addressLine1 : '';
  };

  const getLineItemId = () => {
    if (isMultiSite) {
      return (selectedLineItem && selectedLineItem.lineItemId) || '';
    }

    return connectivityLineItems?.[0]?.lineItemId;
  };

  const getCustomerNeedDate = () => {
    if (isMultiSite) {
      return selectedLineItem && selectedLineItem?.customerNeedDate && moment(new Date(selectedLineItem?.customerNeedDate)).format(DATE_FORMATS.DD_MMM_YYYY);
    }

    return connectivityLineItems && connectivityLineItems?.[0].customerNeedDate && moment(new Date(connectivityLineItems?.[0].customerNeedDate)).format(DATE_FORMATS.DD_MMM_YYYY);
  };

  const getMedia = () => {
    if (isMultiSite) {
      return selectedLineItem?.selectedMedia?.[0]?.media;
    }

    return connectivityLineItems?.[0]?.selectedMedia?.[0]?.media;
  };

  const getRsuCode = () => {
    if (isMultiSite) {
      return selectedLineItem?.selectedMedia?.[0]?.rsuCode;
    }

    return connectivityLineItems?.[0]?.selectedMedia?.[0]?.rsuCode;
  };

  const getPincode = () => {
    if (isMultiSite) {
      return selectedLineItem && selectedLineItem.address && selectedLineItem.address.pincode;
    }

    return order && order.companyAddress && order.companyAddress.pincode;
  };

  const pincode = getPincode();
  const installationAddress = getInstallationAddress();
  const customerNeedDate = getCustomerNeedDate();

  const media = getMedia();
  const rsuCode = getRsuCode();

  const DATE_TODAY_PLUS_4 = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 4);
  const DATE_AFTER_PLUS_9 = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 8);
  const startDateParsed = moment(DATE_TODAY_PLUS_4).format(DATE_FORMATS.YYYY_MM_DD);
  const endDateParsed = moment(DATE_AFTER_PLUS_9).format(DATE_FORMATS.YYYY_MM_DD);

  const MOCK_PARAMS_ENTERPRISE = {
    media,
    startDate: startDateParsed,
    appointmentStartDate: startDateParsed,
    endDate: endDateParsed,
    appointmentEndDate: endDateParsed,
    pincode: getPincode(),
    rsuCode: rsuCode ? rsuCode : 'PDG'
  };

  const apiProps = getFetchSlotApiConfig(MOCK_PARAMS_ENTERPRISE).ENTERPRISE;

  const handleSubmitClick = () => {
    setOpen(false);
  };

  const getIsReschedule = () => {
    if (isMultiSite) {
      return selectedLineItem.siteInstallAppointmentDetail && selectedLineItem.siteInstallAppointmentDetail.appointmentId ? true : false;
    }

    return appointmentData.appointmentDate && appointmentData.startTime && appointmentData.endTime ? true : false;
  };

  const getAppointmentId = () => {
    if (isMultiSite) {
      return selectedLineItem.siteInstallAppointmentDetail.appointmentId;
    }

    return appointmentId;
  };

  const handleWidgetSubmit = async (selectedDate, selectedTime) => {
    try {
      const isReschedule = getIsReschedule();
      const url = isReschedule ? `${appConfig.dedicatedSummaryApiUrl}slots/reschedule` : `${appConfig.dedicatedSummaryApiUrl}slots/book`;
      let data = {
        media,
        rsuCode,
        pincode,
        // appointmentDate: moment(new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), selectedDate.title)).format(DATE_FORMATS.YYYY_MM_DD),
        appointmentDate: moment(new Date(selectedDate?.value)).format(DATE_FORMATS.YYYY_MM_DD),
        lineItemId: getLineItemId(),
        timeInterval: {
          start: `${selectedTime.title.split(' ')[0]}:00`,
          finish: `${selectedTime.title.split(' ')[3]}:00`
        }
      };

      if (isReschedule) {
        data = {
          ...data,
          appointmentId: getAppointmentId()
        };
      }

      const res = isReschedule
        ? await rescheduleSlotsAsync(url, data, getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN))
        : await bookSlotsAsync(url, data, getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN));

      if (res?.status === 200) {
        setSlotBooked?.(true);
        const cb = () => {
          setSelectedAppointmentId(res?.data?.result?.appointmentId);
          setAppointmentData((appointmentData) => ({
            ...appointmentData,
            appointmentDate: moment(new Date(selectedDate?.value)).format(DATE_FORMATS.YYYY_MM_DD),
            startTime: `${selectedTime.title.split(' ')[0]}:00`,
            endTime: `${selectedTime.title.split(' ')[3]}:00`
          }));
        };

        if (isMultiSite) {
          // window?.location?.reload();
        } else {
          fetchOrder(cb);
        }

        setOpen(false);
      }
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleSubmit = () => {
    if (siteReadyByDate > customerNeedByDate) {
      setError('Site readiness date cannot be ahead of customer need by date. Choose a date before the selected customer need by date.');
    } else {
      setError('');
      setOpen(false);
    }
  };

  return (
    <div className={`schedule_widget_container drawer_modal_controller ${open ? 'active' : ''}`}>
      <div className="drawer">
        <div className="drawer_header">
          <div className="drawer_head">
            <div className="title_info">
              <div className="title_heading">{title}</div>
            </div>
            <span
              className="close_icon"
              onClick={() => {
                setOpen(false);
              }}
            ></span>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="site_readiness">
              <div className="form_section">
                {/**
                 * LEFT PANEL
                 */}
                <div className="leftpanel-container">
                  <div className="box">
                    <div className="title">Installation Address</div>
                    <div className="value">{installationAddress}</div>
                  </div>

                  <div className="box">
                    <div className="title">Customer Need by Date</div>
                    <div className="value">{customerNeedDate}</div>
                  </div>
                </div>

                {/**
                 * MAIN PANEL
                 */}
                <div className="mainpanel-container">
                  <div className="site-readiness-section">
                    {
                      selectedOption?.id === 'Yes' || isMultiSite ? (
                        <div className="widget-section">
                          <SchedulingWidget orderDetail={orderDetail} planDetail={planDetail} apiProps={apiProps} onConfirmClick={handleWidgetSubmit} />
                        </div>
                      ) : null
                      //                       <div className="customer-need-by-date-section">
                      //                         <h4 className="heading">Tentative Site Readiness Date</h4>
                      //                         <Datepicker
                      //                           name="datepicker"
                      //                           label="Tentative site readiness date"
                      //                           required={true}
                      //                           errors={[]}
                      //                           touched={false}
                      //                           value={siteReadyByDate}
                      //                           onChange={(value) => setSiteReadyByDate(value)}
                      //                           maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      //                           minDate={new Date()}
                      //                           years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      //                           disabled={false}
                      //                         />
                      // <div className='error-msg'>{error}</div>
                      // <h4 className="heading">Customer Need by Date</h4>
                      //                         <Datepicker
                      //                           name="datepicker"
                      //                           label="Customer Need by Date"
                      //                           required={true}
                      //                           errors={[]}
                      //                           touched={false}
                      //                           value={customerNeedByDate}
                      //                           onChange={(value) => setCustomerNeedByDate(value)}
                      //                           maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      //                           minDate={new Date()}
                      //                           years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      //                           disabled={false}
                      //                         />
                      //                         <div className="button_group">
                      //                           <Button disabled={isNull(siteReadyByDate) || isNull(customerNeedByDate) } onClick={handleSubmit}>
                      //                             Confirm{' '}
                      //                           </Button>
                      //                         </div>
                      //                       </div>
                    }
                  </div>
                  {/* <div className='submit_section'>
                  <Button onClick={handleSubmitClick}>Confirm</Button>
                  </div> */}
                  {/* <div className="customer-need-by-date-section">
                    <h4 className="heading">Customer Need by Date</h4>
                    <Datepicker
                      name="datepicker"
                      label="Customer Need by Date"
                      required={true}
                      errors={[]}
                      touched={false}
                      value={readyByDate}
                      onChange={(value) => setReadyByDate(value)}
                      maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      minDate={new Date()}
                      years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      disabled={false}
                    />
                  </div> */}
                </div>
              </div>
            </div>
            {/* </div> */}
            {/* <div className="upload_docs_area">
                  <UploadComponent isDrawerModal onUploadCb={handleFileUpload} {...props} />
                </div> */}
            {/* </div> */}
          </div>
        </div>
        {/* <div className="drawer_footer">
          <div className="container">
            <div className="button_group">
              <Button
                variant="outlinebtn"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleSubmitClick}>Save</Button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default WidgetComponent;
